import React, { useEffect, useState } from "react";
import "./NewLinkStyles.scss";
import { useDispatch, useSelector } from "react-redux";
import { showSuccess } from "../../../helpers/Notifications/Notification";
import {
  addLibrary,
  editLibrary,
} from "../../../slices/Admin/contolLibrary.slice";
import { URL_REGEX } from "../../../helpers/constants";
import NewFormHeader from "../../../components/Common/NewFormHeader";
import { Button, Input } from "../../../components/ds";

const NewLink = ({
  onClose,
  setDrawerVisible,
  isEdit,
  linkToEdit,
  populateLibraryList,
}) => {
  const { newLibraryError } = useSelector((state) => state.controlLibrary);
  const dispatch = useDispatch();
  const [title, setTitle] = useState(linkToEdit?.title || "");
  const [url, setUrl] = useState(linkToEdit?.url || "");
  const [titleError, setTitleError] = useState("");
  const [urlError, setUrlError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    setTitle(linkToEdit?.title || "");
    setUrl(linkToEdit?.url || "");
    setTitleError("");
    setUrlError("");
    setSubmitting(false);
  }, [linkToEdit]);

  const validateTitle = (value = title) => {
    if (!(value || "").trim()) {
      setTitleError("Please fill the title of the link to proceed!");
      return false;
    }
    setTitleError("");
    return true;
  };

  const validateUrl = (value = url) => {
    const trimmed = (value || "").trim();
    if (!trimmed) {
      setUrlError("Please fill the URL to proceed!");
      return false;
    }
    if (!URL_REGEX.test(trimmed)) {
      setUrlError("Enter a valid URL");
      return false;
    }
    setUrlError("");
    return true;
  };

  const onSubmit = (e) => {
    e.preventDefault();
    const titleOk = validateTitle();
    const urlOk = validateUrl();
    if (!titleOk || !urlOk) return;

    const values = {
      title: title.trim(),
      url: url.trim(),
    };
    setSubmitting(true);

    const finish = (status) => {
      setSubmitting(false);
      if (status === "success") {
        populateLibraryList();
        setDrawerVisible(false);
      }
    };

    if (isEdit) {
      dispatch(
        editLibrary(values, linkToEdit?.id, (status) => {
          if (status === "success") {
            showSuccess("Link details edited");
          }
          finish(status);
        })
      );
    } else {
      dispatch(
        addLibrary(values, (status) => {
          if (status === "success") {
            showSuccess("New Link Added");
          }
          finish(status);
        })
      );
    }
  };

  const serverErrors =
    newLibraryError && typeof newLibraryError === "object"
      ? newLibraryError
      : {};

  return (
    <div className="control-library-add">
      <NewFormHeader
        title={`${isEdit ? "Edit" : "Add"} Link`}
        description={"Fill the following fields to add a new link."}
        error={newLibraryError}
      />
      <form
        onSubmit={onSubmit}
        autoComplete="off"
        style={{ paddingTop: 20 }}
        noValidate
      >
        <div className="ops-form-field">
          <label className="ops-field-label" htmlFor="link-title">
            Title
          </label>
          <Input
            id="link-title"
            type="text"
            placeholder="Title"
            value={title}
            onChange={(e) => {
              setTitle(e.target.value);
              if (titleError) validateTitle(e.target.value);
            }}
            onBlur={() => validateTitle()}
            invalid={Boolean(titleError || serverErrors.title)}
          />
          <span className="field-error">
            {titleError || serverErrors.title || ""}
          </span>
        </div>

        <div className="ops-form-field">
          <label className="ops-field-label" htmlFor="link-url">
            URL
          </label>
          <Input
            id="link-url"
            type="text"
            placeholder="URL"
            value={url}
            onChange={(e) => {
              setUrl(e.target.value);
              if (urlError) validateUrl(e.target.value);
            }}
            onBlur={() => validateUrl()}
            invalid={Boolean(urlError || serverErrors.url)}
            mono
          />
          <span className="field-error">
            {urlError || serverErrors.url || ""}
          </span>
        </div>

        <div className="actions-container">
          <Button
            type="button"
            variant="secondary"
            onClick={onClose}
            disabled={submitting}
          >
            CANCEL
          </Button>
          <Button type="submit" disabled={submitting}>
            {(() => {
              if (submitting) return "Working…";
              if (isEdit) return "UPDATE";
              return "ADD";
            })()}
          </Button>
        </div>
      </form>
    </div>
  );
};

export default NewLink;
